<template>
	<div id="containt">
		<el-tabs v-model="activeName" class="tab-box">
			<el-tab-pane label="常规" name="first">
				<editView v-if="showEdit" visible-key="showEdit" :_dataId.sync="dataId" :parent-target="_self" @reload="$reloadHandle"></editView>
			</el-tab-pane>
			<el-tab-pane label="列表" name="second">
				<div class="grid-height">
					<vxe-grid ref="table-m1" v-bind="vxeOption" @resizable-change="$vxeTableUtil.onColumnWitchChange" @custom="$vxeTableUtil.customHandle">
						<template #form>
							<div class="clearfix screen-btns">
								<div class="fl">
									<vxe-button status="primary" class="button-sty" icon="el-icon-plus" @click="openEditDialog">新增</vxe-button>
                  <vxe-button status="primary" class="button-sty" icon="el-icon-upload2" @click="doExportData()">
                    导出
                  </vxe-button>
								</div>
								<div class="fr">
									<vxe-button icon="el-icon-brush" class="button-sty" @click="resetEvent" type="text" status="primary" plain>重置</vxe-button>
									<vxe-button status="warning" icon="el-icon-search" class="button-sty" @click="searchEvent">搜索</vxe-button>
								</div>
							</div>
							<vxe-form ref="form" class="screen-box" title-width="92px" title-align="right" :data="formData" @submit="searchEvent" @reset="searchEvent">
								<vxe-form-item title="品牌名称:" field="brandName">
									<template v-slot>
										<el-input v-model="formData.brandName" size="small" clearable />
									</template>
								</vxe-form-item>
								<vxe-form-item title="状态:" field="usable">
									<template v-slot>
										<el-select v-model="formData.usable" clearable>
											<el-option :value="1" label="启用"></el-option>
											<el-option :value="0" label="禁用"></el-option>
										</el-select>
									</template>
								</vxe-form-item>
							</vxe-form>
						</template>
					</vxe-grid>
				</div>
			</el-tab-pane>
		</el-tabs>
	</div>
</template>

<script>
import editView from './edit.vue';
import {tableOption} from '@/const/crud/admin/tenant';
import {initVxeTable} from '@/const/crud/admin/table'
export default {
	name: 'tenantlist',
	components: { editView },
	data() {
		return {
			activeName: 'second',
			dataId: 0,
			showEdit: false,
			vxeOption: {},
			formData: {},
		};
	},
	mounted() {
		this.initTableList();
	},
	methods: {
		searchEvent() {
			this.$refs['table-m1'].commitProxy('reload');
		},
		resetEvent() {
			this.formData = {};
			this.$refs['table-m1'].commitProxy('reload');
		},
    doExportData(){
      this.$refs['table-m1'].exportData();
    },
		openEditDialog(id) {
			this.dataId = !id || typeof id == 'object' ? 0 : id;
			this.activeName = 'first';
			this.$openEditView('showEdit');
		},
		initTableList() {
			let that = this;
			let tableOption = {
				vue: this,
				tableRef: 'table-m1',
				tableName: 'basic_fault_code_list-m1',
				path: '/basic/basOrderType/getListPage',
				param: this.formData,
        method:'post',
        height:'800px',
        export:true,
				columns: [
					{ type: 'checkbox', width: 48, resizable: false, fixed: 'left' },
					{
						title: '品牌名称',
						field: 'brandName',
						width: 150,
						fixed: 'left'
					},
					{
						title: '品牌图片',
						field: 'pic',
						width: 150
					},
					{
						field: 'usable',
						title: '状态',
						width: 150,
						slots: {
							default: ({ row }) => {
								if (row.usable == 0) {
									return [
										<div class="txt-status">
											<span>禁用</span>
										</div>
									];
								} else if (row.usable == 1) {
									return [
										<div class="txt-status disable">
											<span>启用</span>
										</div>
									];
								}
							}
						}
					},
					{
						field: 'createTime',
						title: '创建时间',
						width: 150
					},
					{
						width: 47,
						fixed: 'right',
						title: '',
						sortable: false,
						slots: {
							default: ({ row }) => {
								return [
									<div>
										<a
											href="javascript:void(0);"
											class="a-link"
											onclick={() => {
												this.openEditDialog(row.id);
											}}
										>
											<el-tooltip enterable={false} effect="dark" content="查看" placement="top" popper-class="tooltip-skin">
												<i class="el-icon-edit" />
											</el-tooltip>
										</a>
									</div>
								];
							}
						}
					}
				]
			};
      // initVxeTable(tableOption).then(opts => {
				this.vxeOption =  initVxeTable(tableOption);
			// });
		},
	}
};
</script>
